module.exports = __webpack_public_path__ + "static/media/pencil.15a62aa2.png";